import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "amfe-flexible";
import storage from "./common/utils/storage";

// import "@fontsource/noto-sans-sc/400.css";  // 指定 400 字重
// import "@fontsource/noto-sans-sc/700.css";  // 指定 700 字重

import VuePageStack from 'vue-page-stack';
Vue.use(VuePageStack, { router });

import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);

import "@/styles/base.scss";

// const acPlayerToolInit = window.acPlayerToolInit;
// Vue.prototype.TCPlayer = acPlayerToolInit;

import Swiper2, {EffectFade, Navigation, Pagination, EffectCards, EffectCoverflow, Autoplay } from 'swiper'
Swiper2.use([EffectFade, Navigation, Pagination, EffectCards, EffectCoverflow, Autoplay]);
import VueAwesomeSwiper from "vue-awesome-swiper";
import 'swiper/swiper-bundle.css';
Vue.use(VueAwesomeSwiper);

import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import { VueMasonryPlugin } from 'vue-masonry'
Vue.use(VueMasonryPlugin)

import * as custom from './common/filters'
Object.keys(custom).forEach(key => { Vue.filter(key, custom[key])});

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

axios.interceptors.request.use(
  config => {
    if(sessionStorage.getItem("Token")) {
      config.headers.common["token"] = sessionStorage.getItem("Token");
    }
    return config;
  },
  error => {
    console.log(error);
  }
);

axios.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.RetCode == '10000') {
      return res;
    } else if (res.RetCode == '10001') {
      return res;
    } else {
      return Promise.reject(new Error(res.RetMsg || 'Error'));
      // return res;
    }
  },
  error => {
    return Promise.reject(error);
  }
)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
